<script lang="ts">
  let { side }: { side: "top" | "bottom" | "left" | "right" } = $props()
</script>

<span class="border-(--border) bg-(--bg) {side}"></span>

<style lang="postcss">
  /* common arrow styling */
  span::before,
  span::after {
    content: "";
    position: absolute;
  }

  /* Arrow top */
  :global(.tooltip-content[data-side="top"]) {
    & span::after,
    & span::before {
      transform: translateX(-50%);
      border-left: var(--arrow-height) solid transparent;
      border-right: var(--arrow-height) solid transparent;
      top: 100%;
      left: 50%;
    }
    & span::before {
      border-top: var(--arrow-height) solid var(--border);
      margin-top: 0px;
    }

    /* The white fill of the triangle */
    & span::after {
      border-top: var(--arrow-height) solid var(--bg);
      margin-top: -2px;
      z-index: 1;
    }
  }

  /* Arrow bottom */
  :global(.tooltip-content[data-side="bottom"]) {
    & span::after,
    & span::before {
      transform: translateX(-50%);
      border-left: var(--arrow-height) solid transparent;
      border-right: var(--arrow-height) solid transparent;
      bottom: 100%;
      left: 50%;
    }

    & span::before {
      border-bottom: var(--arrow-height) solid var(--border);
      margin-bottom: 0px;
    }

    /* The white fill of the triangle */
    & span::after {
      border-bottom: var(--arrow-height) solid var(--bg);
      margin-bottom: -2px;
      z-index: 1;
    }
  }

  /* Arrow left */
  :global(.tooltip-content[data-side="left"]) {
    & span::after,
    & span::before {
      transform: translateY(-50%);
      border-top: var(--arrow-height) solid transparent;
      border-bottom: var(--arrow-height) solid transparent;
      top: 50%;
      left: 100%;
    }

    & span::before {
      border-left: var(--arrow-height) solid var(--border);
      margin-left: 0px;
    }

    /* The white fill of the triangle */
    & span::after {
      border-left: var(--arrow-height) solid var(--bg);
      margin-left: -2px;
      z-index: 1;
    }
  }

  /* Arrow right */
  :global(.tooltip-content[data-side="right"]) {
    & span::after,
    & span::before {
      transform: translateY(-50%);
      border-top: var(--arrow-height) solid transparent;
      border-bottom: var(--arrow-height) solid transparent;
      top: 50%;
      right: 100%;
    }

    & span::before {
      border-right: var(--arrow-height) solid var(--border);
      margin-right: 0px;
    }

    /* The white fill of the triangle */
    & span::after {
      border-right: var(--arrow-height) solid var(--bg);
      margin-right: -2px;
      z-index: 1;
    }
  }
</style>
